import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { type PercWatchtimeResponse } from '@/types/all-profiles.types';
import { arrayToMap } from '@/utils/array-to-map';

export const setAllProfilesWatchtime = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<PercWatchtimeResponse[]>((state, action) => {
    const map = arrayToMap<PercWatchtimeResponse>('bl_profile', action.payload);
    state.allProfiles.users = state.allProfiles.users.map((user) => ({
      ...user,
      perc_watchtime: user.bl_profile ? map.get(user.bl_profile)?.perc_watchtime : '0%',
    }));
    state.allProfiles.loadingWatchtime = false;
  });
